import { render, staticRenderFns } from "./product_hair3.vue?vue&type=template&id=15f50c4f&scoped=true&"
import script from "./product_hair3.vue?vue&type=script&lang=js&"
export * from "./product_hair3.vue?vue&type=script&lang=js&"
import style0 from "./product_hair3.vue?vue&type=style&index=0&id=15f50c4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f50c4f",
  null
  
)

export default component.exports